import {createRoot} from 'react-dom/client'
import {IntlProvider} from 'react-intl'
import {RouterProvider, createBrowserRouter} from 'react-router-dom'
import {ToastFactory} from '@mds/mds-reactjs-library'

import {GlobalTheme} from 'catalystZeroComponents/globalTheme'

import App from './App'
import {defaultLocale, messages} from './i18n'
import Logout from './routes/logout'
import {LOGOUT_PATH} from './utils/constants'
import './style.css'
import style from './App.module.css'

const container = document.getElementById('catalystzero-container-fe')

const root = createRoot(container!)

const router = createBrowserRouter([
  {
    path: LOGOUT_PATH,
    element: <Logout />
  },
  {
    path: '*',
    element: <App />
  }
])

root.render(
  <IntlProvider defaultLocale={defaultLocale} locale={navigator.language} messages={messages}>
    <GlobalTheme>
      <RouterProvider router={router} />
      {/* @ts-ignore this could be removed by upgrading to mds version 3 */}
      <ToastFactory className={style.toastContainer} />
    </GlobalTheme>
  </IntlProvider>
)
